// extracted by mini-css-extract-plugin
export var container = "_9r-0";
export var error = "_9r-9";
export var label = "_9r-5";
export var light = "_9r-6";
export var md = "_9r-3";
export var sm = "_9r-2";
export var thin = "_9r-8";
export var thinBold = "_9r-7";
export var vertical = "_9r-4";
export var xs = "_9r-1";